import script from "./[id].vue?vue&type=script&setup=true&lang=ts"
export * from "./[id].vue?vue&type=script&setup=true&lang=ts"

import "./[id].vue?vue&type=style&index=0&id=892ff682&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-892ff682"]])

export default __exports__